import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import FormTextArea from 'partial/components/form/FormTextArea';

import Button from 'partial/components/Button';
import { useUpdateMaskName } from '../hooks';

export const useOpenUpdateMaskName = () => {
  const createModal = useCreateModal();

  const openUpdateMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <UpdateMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openUpdateMaskNameModal;
};

const status = {
  approve: 'APPROVED',
  reject: 'REJECTED',
};

function UpdateMaskName({ onClose, data }) {
  const [remarks, setRemarks] = useState('');
  const [isLoading, update] = useUpdateMaskName({
    onSuccess: onClose,
    onError: onClose,
  });
  const isApprove = data?.action === 'approve';

  const submit = () => {
    update({
      uuid: data?.uuid,
      payload: { status: status?.[data?.action], remarks },
    });
  };

  const isDisabled = useMemo(
    () => (isApprove ? false : remarks.length === 0),
    [isApprove, remarks],
  );

  return (
    <ModalCard
      size="sm"
      title={`${
        data?.action === 'approve' ? 'APPROVE' : 'DISAPPROVE'
      } MASKNAME`}
      onClose={onClose}
    >
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to{' '}
          {data?.action === 'approve' ? 'approve' : 'disapprove'} this mask name
          <span className="text-primary"> {data?.name}</span>?
        </p>
        {data?.action !== 'approve' && (
          <FormTextArea
            name="remarks"
            onSetFieldValue={(_, value) => setRemarks(value)}
            value={remarks}
            label="Reason for Disapproval"
            required
          />
        )}
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isDisabled || isLoading}
            outline
            className="uppercase"
            onClick={submit}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

UpdateMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateMaskName;
